<template>
  <div class="widget">
    <widget-header
      :text="header"
      :color="color"
      @close="$emit('close')"
    />

    <div class="widget__body">
      <slot />
    </div>

    <widget-footer />
  </div>
</template>

<script lang="ts">
import WidgetFooter from '@widgets/shared/components/WidgetFooter.vue'
import WidgetHeader from '@widgets/shared/components/WidgetHeader.vue'
import { defineComponent } from '@/composition/vue/compositionApi'

export default defineComponent({
  components: {
    WidgetHeader,
    WidgetFooter,
  },
  props: {
    header: {
      type: String,
    },
    color: {
      type: String,
    },
  },
  emits: {
    close: () => true,
  },
})
</script>

<style lang="scss" scoped>
.widget {
  background: $white;
  box-shadow: 0 0 8px rgba(99, 99, 99, 0.25);
  border-radius: $border-radius-md;
  min-height: 580px;
  max-width: 400px;
  display: flex;
  flex-direction: column;

  &__body {
    padding: 30px 36px;
    flex-grow: 1;
    flex-shrink: 1;
    display: flex;
    flex-direction: column;

    @include media-sm-max {
      padding: 24px 16px;
    }
  }
}
</style>
